var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps-link",class:{
    'steps-link__pass': _vm.isPass
  }},[_c('div',{staticClass:"big-point"}),_c('div',{staticClass:"point"}),_c('div',{staticClass:"point"}),_c('div',{staticClass:"point"}),_c('div',{staticClass:"point"}),_c('div',{staticClass:"point"}),_c('div',{staticClass:"big-point"})])}
var staticRenderFns = []

export { render, staticRenderFns }